<template>
    <a-row type="flex" class="vedeo-container">
        <a-col class="list-wrap scroll-container">
            <div class="m-b-8">
                <a @click.stop="backVedio" style="color:#40a9ff"
                    ><a-icon type="arrow-left" /> 返回</a
                >
            </div>
            <div class="cameraList">
                <li
                    @click="selectChannel(item, key)"
                    v-for="(item, key) in cameraList"
                    :key="key"
                >
                    <a>{{ item.channelName }}</a>
                </li>
            </div>
        </a-col>
        <a-col class="vedio-wrap">
            <!--ezopen:// [设备验证码@] open.ys7.com/[deviceSerial]/[channelNo] [.hd].live
        设备验证码:BDZYWK
        设备序列号：F43457002 
        channelNo:12
        token：741a1f70-8688-421d-97c7-d5a1d0344fe8-->

            <iframe
                v-if="iframeurl"
                :src="iframeurl"
                width="560"
                height="450"
                id="ysOpenDevice"
                allowfullscreen
            ></iframe>
        </a-col>
    </a-row>
</template>
<script>
    export default {
        data() {
            return {
                ocx: {},
                cameraList: [],
                iframeurl: '',
                accessToken: '',
                index: 0
            }
        },
        created() {
            this.queryCameraList()
        },
        mounted() {},
        methods: {
            queryCameraList() {
                let params = {
                    storeId: 'd43786b9fe2f4460a6bc0f7fc0320edd',
                    pageNo: 1,
                    pageSize: 30
                }
                this.$api.queryCameraLists(params).then((res) => {
                    if (res.code === 200) {
                        this.cameraList = res.data.rows
                        this.$api.queryCameraAccountInfo().then((res) => {
                            if (res.code === 200) {
                                this.accessToken = res.data.token
                                this.iframeurl =
                                    'https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://BDZYWK@open.ys7.com/' +
                                    this.cameraList[this.index].deviceSerial +
                                    '/' +
                                    this.cameraList[this.index].channelNo +
                                    '.live' +
                                    '&accessToken=' +
                                    res.data.token
                                console.log('88888>', this.iframeurl)
                            }
                        })
                    }
                })
            },
            selectChannel(item, index) {
                console.log(item)
                this.index = index
                this.iframeurl =
                    'https://open.ys7.com/ezopen/h5/iframe_se?url=ezopen://BDZYWK@open.ys7.com/' +
                    this.cameraList[this.index].deviceSerial +
                    '/' +
                    this.cameraList[this.index].channelNo +
                    '.live' +
                    '&accessToken=' +
                    this.accessToken
            },
            isIE() {
                // if (!!window.ActiveXObject || "ActiveXObject" in window) {
                //     return true
                // } else {
                //     return false
                // }
            },
            backVedio() {
                this.$emit('hideVedio')
            }
        }
    }
</script>
<style lang="scss" scoped>
    .vedeo-container {
        width: 100%;
        height: 100%;
        padding: 10px;
        .list-wrap {
            width: 140px;
            padding: 0 10px;

            .cameraList {
                height: 450px;
                overflow-y: auto;
                overflow-x: hidden;
                li {
                    text-align: center;
                    height: 36px;
                    line-height: 36px;
                    background: rgba(100, 149, 237, 0.5);

                    margin-bottom: 10px;
                    border-radius: 2px;
                    width: 100%;
                    overflow: hidden;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    padding: 0 8px;
                }
            }
        }
        .vedio-wrap {
            width: calc(100% - 160px);
            height: calc(100% - 40px);
            background: black;
            margin: 28px 10px 10px 10px;
        }
    }
</style>
